import { Button, localForageHelper } from '@hub/shared'
import { useCallback, useEffect, useState } from 'react'

interface Props {
  valueChange?: (hideValue: boolean) => any
}

export default ({ valueChange }: Props) => {
  const [hideValue, setHideValue] = useState(true)

  const handleChange = useCallback(
    async (value: boolean) => {
      await localForageHelper.setItem('hideValue', value).then((event: boolean) => {
        if (event !== hideValue) {
          setHideValue(event)
        }

        if (valueChange && typeof valueChange === 'function') {
          valueChange(event)
        }
      })
    },
    [hideValue, valueChange]
  )

  useEffect(() => {
    localForageHelper.getItem('hideValue').then((event: any) => {
      handleChange(event)
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Button onClick={() => handleChange(!hideValue)} color="transparent" textColor="var(--text_color)" borderStyle="none" inverted>
      <i className={`fa-solid ${hideValue ? 'fa-eye-slash' : 'fa-eye'}`} style={{ fontSize: '1.3rem' }}></i>
    </Button>
  )
}
